import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type CardData = {
    id: number
    title: string
    percent: number
    image: string
    cardId: any
    card: any
}

type CardDataDto = {
    title: string
    percent: number
    image: string
}

export const CardDataApi = createApi({
    reducerPath: 'CardDataApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getCardData: builder.query<CardData, { id: number }>({
            query: id => ({ url: `/carddataitems/${id}` })
        }),
        getAllCardData: builder.query<CardData[], void>({
            query: () => ({ url: '/carddataitems' })
        }),
        createCardData: builder.mutation<any, CardDataDto>({
            query: (data)=> ({url: `/carddataitems`, method: "POST", body: data}),
        }),
    })
})

export const { useGetCardDataQuery, useGetAllCardDataQuery, useCreateCardDataMutation } = CardDataApi
